import { AppState, DispatchAction } from './AppProvider'

export type LoginReducer = (state: AppState, action: DispatchAction) => AppState

export const loginReducer: LoginReducer = (
  state: AppState,
  action: DispatchAction
) => {
  switch (action.type) {
    case 'SET_TENANT':
      return {
        ...state,
        tenant: { ...state.tenant, id: action.tenantId },
      }
    case 'SET_USER_INFO':
      const tenant = action.tenantId
        ? { ...state.tenant, id: action.tenantId }
        : { ...state.tenant }
      const role = action.role ?? state.role
      const permissions = action.permissions ?? state.permissions
      const user = action.user ? { ...state.user, ...action.user } : state.user
      return {
        ...state,
        tenant,
        user,
        role,
        permissions,
      }
    case 'SET_ACCESS_TOKEN':
      return {
        ...state,
        accessToken: action.accessToken,
      }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}
